import React from 'react';
import { GenericButton } from 'components/GenericButton';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import {
  SET_PROFILE_FORM_FIELD,
  SET_PROFILE_LAYOUT_TYPE,
} from '../redux/profile.types';
import { AddProfileButton } from './AddProfileButton';
import { ProfileAvatar } from './ProfileAvatar';
import { ProfilesHeader } from './ProfilesHeader';

export const ManageProfilesView = () => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const { profilesInfo } = useSelector(state => state.profilesManager);
  const maxAvatarsClass = profilesInfo.members?.length >= 4 ? 'max-avatars' : ''

  const handleEditProfile = (e, profileInfo) => {
    e.stopPropagation();
    const { user_image, is_kids, username, gamification_id } = profileInfo;
    dispatch({
      type: SET_PROFILE_FORM_FIELD,
      payload: {
        user_image,
        is_kids: is_kids === 'false' ? false : true,
        firstname: username,
        gamification_id,
      },
    });
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'EDIT_PROFILE' });
  };

  const handleChangeView = () => {
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'SELECT_PROFILE' });
  };

  return (
    <>
      <ProfilesHeader />
      <section className="manage-profiles-view profiles-common__container fade__in">
        <h2 className="manage-profiles-view__title profiles-common__container__title">
          {getTranslation('manageProfiles_access_title_label', translations)}
        </h2>
        <div className={`manage-profiles-view__profiles profiles-common__container__avatars ${maxAvatarsClass} fade__in`}>
          {profilesInfo?.members?.map(profile => (
            <ProfileAvatar
              key={`manage-profiles-key-${profile.partnerUserId}`}
              avatarSrc={profile?.user_image}
              profileName={profile?.username}
              onClick={e => handleEditProfile(e, profile)}
              editable
            />
          ))}
          {profilesInfo.members?.length < profilesInfo.maxMembers && <AddProfileButton />}
        </div>
        <GenericButton
          textContent={getTranslation(
            'manageProfiles_access_option_button_ok',
            translations,
          )}
          onClick={handleChangeView}
          classNames={['select-profile-view__manage-button']}
        />
      </section>
    </>
  );
};
